var exports = {
  "Z8": "BioEditor.module__emojiButton___SHJjSH",
  "Dg": "BioEditor.module__emojiButtonActive___SHJjSH",
  "h_": "BioEditor.module__description___SHJjSH",
  "EN": "BioEditor.module__editor___SHJjSH",
  "E": "BioEditor.module__characterCountContainer___SHJjSH",
};

module.exports = exports;
